export const announcementsData$ = (state) => state.announcement.announcements;
export const announcementsLoading$ = (state) => state.announcement.isLoading;
export const announcementsError$ = (state) => state.announcement.error;
export const announcementDismissing$ = (state) => state.announcement.isDismissing;
export const announcementDismissError$ = (state) => state.announcement.dismissError;
